import { Renderer } from "./types";

/**
 * Generic registry for managing renderers
 */
export class RendererRegistry<TContent> {
  private renderers: Renderer<TContent>[] = [];

  /**
   * Register a new renderer
   */
  register(renderer: Renderer<TContent>): void {
    this.renderers.push(renderer);
  }

  /**
   * Get all renderers that can handle the given content
   */
  getRenderers(content: TContent): Renderer<TContent>[] {
    return this.renderers.filter((renderer) => renderer.canRender(content));
  }

  /**
   * Get all registered renderers
   */
  getAllRenderers(): Renderer<TContent>[] {
    return [...this.renderers];
  }

  /**
   * Clear all registered renderers
   */
  clear(): void {
    this.renderers = [];
  }
}
